<script lang="ts">
  import {createEventDispatcher, onMount} from 'svelte';

  export let value: any = '';
  export let title: string = '';
  export let align: string = '';
  const dispatch = createEventDispatcher();

  function increment() {
    value++;
    dispatch('update', value);
  }

  function decrement() {
    value--;
    dispatch('update', value);
  }

  onMount(() => {
    value = Number.parseInt(value);
  });
</script>

<div class="block {align == 'left' ? 'ml-auto' : ''}">
  <span class="mb-1 block text-xs">{title}</span>
  <div class="flex items-center rounded-lg border border-zinc-200 bg-white">
    <button class="p-2 text-xs font-bold" on:click={decrement} on:keypress={increment}>
      <i class="fa fa-minus" />
    </button>
    <input
      class="w-10 px-2 py-1 text-center text-center text-sm"
      bind:value
      on:change={() => dispatch('update', value)}
    />
    <button class="p-2 text-xs font-bold" on:click={increment} on:keypress={decrement}>
      <i class="fa fa-plus" />
    </button>
  </div>
</div>
